module.exports = __webpack_public_path__ + "static/ZooskLogo-4b5710a91db3f9fa66a872dcbc2592a2.png";